<template>
  <div class="w-full flex flex-col">
    <!-- Nawigacja -->
    <navigation-bar :dark-mode="true" />

    <!-- Sekcja kontaktowa -->
    <div class="w-full flex flex-1 flex-col sm:flex-row bg-[#F7F7F7] items-stretch pt-16">
      <!-- Lewa kolumna (Informacje kontaktowe) -->
      <div class="w-full sm:w-1/2 bg-gray-100 flex items-center justify-center h-full">
        <contact-template class="w-full p-6" />
      </div>

      <!-- Prawa kolumna (Formularz kontaktowy) -->
      <div class="w-full sm:w-1/2 bg-[#002A4A] flex items-center justify-center h-full">
        <contact-form class="w-full p-6" />
      </div>
    </div>
  </div>
  <FooterBar />
</template>

<script>
import NavigationBar from "@/components/common/navigation.vue";
import ContactTemplate from "@/components/contact/contactInformation.vue";
import ContactForm from "@/components/contact/contactForm.vue";
import FooterBar from "@/components/common/footer.vue";

export default {
  components: {
    NavigationBar,
    ContactTemplate,
    ContactForm,
    FooterBar
  }
};
</script>

<style scoped>
html, body {
  margin: 0;
  padding: 0;
  height: 100%;
}

@media (max-width: 640px) {
  .flex {
    flex-direction: column;
  }
}
</style>
